import {PackageSizeItem} from "@shared/algolia/results/components/ResultComponents/hit-types";

export const buildProductPackageSizesList = (packageSizeItem: PackageSizeItem, alternativePackageSizes: []) => {

  let packageSizesList: PackageSizeItem[] = []

  const defaultItem: PackageSizeItem = {
    name: packageSizeItem.name,
    image_url: packageSizeItem.image_url,
    eyecatcher: packageSizeItem.eyecatcher,
    pzn: packageSizeItem.pzn,
    amount_unit: packageSizeItem.amount_unit,
    price_no_format: packageSizeItem.price_no_format,
    avp_no_format: packageSizeItem.avp_no_format,
    avp_formatted: packageSizeItem.avp_formatted,
    price_formatted: packageSizeItem.price_formatted,
    product_url: packageSizeItem.product_url,
    rating: packageSizeItem.rating,
    rating_count: packageSizeItem.rating_count,
    status_text: packageSizeItem.status_text,
    status_number: packageSizeItem.status_number,
    herbal: packageSizeItem.herbal,
    homeopathic: packageSizeItem.homeopathic,
    prescription_required: packageSizeItem.prescription_required,
    presentation_form: packageSizeItem.presentation_form,
    base_price: packageSizeItem.base_price,
    products_id: packageSizeItem.products_id
  }

  packageSizesList.push(defaultItem)

  alternativePackageSizes.map((alternativePackageSizeItem) => {
    packageSizesList.push({
      name: alternativePackageSizeItem['name'],
      image_url: alternativePackageSizeItem['image_url'],
      eyecatcher: alternativePackageSizeItem['eyecatcher'],
      pzn: alternativePackageSizeItem['pzn'],
      amount_unit: alternativePackageSizeItem['amount_unit'],
      price_no_format: alternativePackageSizeItem['price_no_format'],
      avp_no_format: alternativePackageSizeItem['avp_no_format'],
      avp_formatted: alternativePackageSizeItem['avp_formatted'],
      price_formatted: alternativePackageSizeItem['price_formatted'],
      product_url: alternativePackageSizeItem['product_url'],
      rating: alternativePackageSizeItem['rating'],
      rating_count: alternativePackageSizeItem['rating_count'],
      status_text: alternativePackageSizeItem['status_text'],
      status_number: Number(alternativePackageSizeItem['status_number']),
      herbal: alternativePackageSizeItem['herbal'],
      homeopathic: alternativePackageSizeItem['homeopathic'],
      prescription_required: alternativePackageSizeItem['prescription_required'],
      presentation_form: alternativePackageSizeItem['presentation_form'],
      base_price: alternativePackageSizeItem['base_price'],
      products_id: alternativePackageSizeItem['products_id']
    })
  })

  return packageSizesList
}